// https://github.com/giantcz/gia
// Add import to js/components
import Component from 'gia/Component'

export default class StoreLocatorComponent extends Component {
  
  constructor(element) {
    super(element);
    this.options = this.getInitialProps();
  }
  
  getInitialProps() {
    let data = {}
    try {
      data = JSON.parse(document.querySelector('script[type="application/json"]', this).innerText)
    }
    catch (e) {}
    return data
  }
  
  mount() {
    // console.log('this.options', this.options);
    var asl = this.options[0];
    var div = document.createElement("div");
    div.innerHTML = asl;
    this.element.appendChild(div);
  }
  
}